import { ADD_BOOKING, REMOVE_BOOKING } from "./actionTypes";

export const add_booking = (value) => {
  return {
    type: ADD_BOOKING,
    payload: value,
  };
};

export const remove_booking = (value) => {
  return {
    type: REMOVE_BOOKING,
    payload: value,
  };
};
